(() => {
  if (window.akGiftsInitialized) return;
  window.akGiftsInitialized = true;
  const cache = new Map();
  const queue = [];
  let running = 0;
  const schedule = task => new Promise((resolve, reject) => { queue.push({task, resolve, reject}); pump(); });
  function pump() {
    while (running < 3 && queue.length) {
      const {task, resolve, reject} = queue.shift(); running++;
      Promise.resolve().then(task).then(resolve, reject).finally(() => { running--; pump(); });
    }
  }
  const cents = value => value === '' || value == null ? null : Math.round(Number(value) * 100);
  function loadCard(card, root) {
    const url = new URL(card.href);
    url.searchParams.set('view', 'ak-gift-preview');
    url.searchParams.delete('gift');
    const key = url.href;
    if (!cache.has(key)) cache.set(key, schedule(async () => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 12000);
      try {
        const response = await fetch(url, {credentials:'same-origin', signal:controller.signal});
        if (!response.ok) throw new Error('Gift category unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = doc.querySelector('[data-gift-preview]');
        if (!data || data.dataset.handle !== card.dataset.handle) throw new Error('Unexpected gift response');
        const min = cents(root.dataset.min), max = cents(root.dataset.max);
        if (min !== null || max !== null) {
          if (data.dataset.priceFilter !== 'true') throw new Error('Price filter unavailable');
          const actualMin = data.dataset.minCents === '' ? null : Number(data.dataset.minCents);
          const actualMax = data.dataset.maxCents === '' ? null : Number(data.dataset.maxCents);
          // Shopify may clamp a maximum above the category's highest price.
          if (min !== null && actualMin !== min) throw new Error('Price minimum not retained');
          if (max !== null && (actualMax === null || actualMax > max)) throw new Error('Price maximum not retained');
        }
        const count = Number(data.dataset.count);
        if (!Number.isFinite(count) || count < 0) throw new Error('Invalid gift count');
        const img = data.querySelector('img');
        return {count, src:img?.getAttribute('src'), alt:img?.getAttribute('alt') || ''};
      } finally {clearTimeout(timer);}
    }).catch(error => {cache.delete(key); throw error;}));
    return cache.get(key).then(data => {
      card.dataset.state = data.count ? 'ready' : 'empty';
      card.dataset.count = String(data.count);
      if (!data.count) {card.hidden = true; return;}
      const img = card.querySelector('[data-gift-image]');
      if (img && data.src) {img.src = data.src; img.alt = data.alt;}
      else if (img) img.parentElement.hidden = true;
      card.querySelector('[data-gift-count]').textContent = `${new Intl.NumberFormat('hu-HU').format(data.count)} ajándék →`;
      card.hidden = false;
    });
  }
  async function loadGroup(group, root) {
    if (group.dataset.loading === 'true') return;
    group.dataset.loading = 'true';
    const status = group.querySelector('[data-gift-status]');
    const retry = group.querySelector('[data-gift-retry]');
    status.hidden = false; status.textContent = 'Ajándékok ellenőrzése…'; retry.hidden = true;
    const cards = [...group.querySelectorAll('[data-gift-card]')];
    await Promise.allSettled(cards.filter(card => card.dataset.state !== 'ready' && card.dataset.state !== 'empty').map(card => loadCard(card, root).catch(error => {card.dataset.state = 'error'; throw error;})));
    const errors = cards.filter(card => card.dataset.state === 'error').length;
    const ready = cards.filter(card => card.dataset.state === 'ready').length;
    if (errors) {status.textContent = 'Néhány kategória most nem tölthető be. Próbáld újra.'; retry.hidden = false;}
    else if (!ready) status.textContent = 'Ebben az árkeretben most nincs elérhető ajándék ezekben a kategóriákban. Válassz másik árkeretet fent.';
    else status.hidden = true;
    group.dataset.loading = 'false'; group.dataset.loaded = 'true';
  }
  function preserveOrigin() {
    const root = document.querySelector('[data-gift-results]');
    if (!root) return;
    const handle = new URL(location.href).searchParams.get('gift');
    const origin = [...root.querySelector('[data-gift-origins]').content.querySelectorAll('a')].find(a => a.dataset.handle === handle);
    if (!origin) return;
    root.querySelector('[data-gift-back]').href = origin.getAttribute('href');
    const label = root.querySelector('[data-gift-budget-label]');
    if (label.textContent !== origin.textContent) label.textContent = origin.textContent;
    document.querySelectorAll('[data-gift-origin]').forEach(input => {input.value = handle;});
  }
  function init(scope = document) {
    preserveOrigin();
    scope.querySelectorAll('[data-gift-browser]').forEach(root => {
      if (root.dataset.initialized) return; root.dataset.initialized = 'true';
      root.querySelectorAll('[data-gift-group]').forEach(group => {
        group.querySelector('[data-gift-retry]').addEventListener('click', () => loadGroup(group, root));
        if (group.hasAttribute('data-lazy')) group.closest('details').addEventListener('toggle', event => {if(event.target.open && !group.dataset.loaded) loadGroup(group, root);});
        else loadGroup(group, root);
      });
    });
  }
  init(); document.addEventListener('shopify:section:load', () => init());
  const main = document.getElementById('MainContent');
  if (main && document.querySelector('[data-gift-results]')) new MutationObserver(preserveOrigin).observe(main, {childList:true, subtree:true});
})();
